module.exports = __webpack_public_path__ + "static/media/background_footer.276221c8.svg";